<template>
	<div class="salemainpage">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px 32px 16px 16px; min-width: 1192px;">
					<div class="contentcard">
						<div style="margin-bottom: 20px;">
							<a-button-group>
								<a-button style="width: 100px;" type="primary" @click="gotopage('skumanagement')">SKU管理</a-button>
								<a-button style="width: 100px;" type="primary" @click="gotopage('terminalmanagement')">端管理</a-button>
								<a-button style="width: 100px;" type="primary" :disabled="is_old_data" @click="targetbtn">目标制定</a-button>
								<a-button style="width: 100px;" type="primary" @click="newlogbtn">新增记录</a-button>
							</a-button-group>
							<div style="display: inline-block;float: right;">
								<a-select :value="year" style="width: 120px" @change="yearChange">
									<a-select-option :value="year" v-for="(year,index) in yearlist" :key="index">
										{{year}}
									</a-select-option>
								</a-select>
								<a-select :value="quarter" style="width: 120px" @change="quarterChange">
									<a-select-option :value="1">
										第一季度
									</a-select-option>
									<a-select-option :value="2">
										第二季度
									</a-select-option>
									<a-select-option :value="3">
										第三季度
									</a-select-option>
									<a-select-option :value="4">
										第四季度
									</a-select-option>
								</a-select>
								<a-button style="width: 100px;" type="primary" @click="search_btn">搜索</a-button>
							</div>
						</div>
						<div v-if="reloading" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;padding: 30px 50px;">
							<a-spin />
						</div>
						<div v-if="!reloading">
							<a-table :columns="columns" :data-source="data" :scroll="scroll_info" :pagination="false">
								<a-table slot="expandedRowRender" slot-scope="record, index, indent" :columns="innerColumns" :dataSource="data[index].innerData"
								 size="middle" :pagination="false" bordered>
									<span slot="operation" slot-scope="text,record">
										<a :disabled="!record.can_compile" @click="bianjibtn(record)">修改</a>
									</span>
								</a-table>
							</a-table>
						</div>
					</div>
					<div class="sale_rule">
						<p class="sale_rule_title">基数值：</p>
						<p class="sale_rule_info">3月的实际销售量*3=季度基数值</p>
						<p class="sale_rule_title">激励原则：</p>
						<p class="sale_rule_info">从4月开始设定奖金池，以季度为单位计算奖金池金额，季度发放。奖励部分：以季度为单位，超出基数值的部分，按照“超出数量”*“奖金系数金额”的计算方式，计入奖金池。</p>
						<p class="sale_rule_info">扣除部分：每个月损耗按照成本从奖金池中扣除，包括产品成本以及运输成本。损耗部分包括未售出报废以及作为赠品赠送部分。</p>
						<p class="sale_rule_info">发放：7月15号，奖金池内金额按照约定比例，与工资一并扣税、发放。</p>
						<p class="sale_rule_title">在规则内的渠道：</p>
						<p class="sale_rule_info">所有现有线上渠道销售，包括：</p>
						<p class="sale_rule_info" style="text-indent:4em;">淘宝店“Freshin鲜入为主官方店”；</p>
						<p class="sale_rule_info" style="text-indent:4em;">小程序“Freshin鲜入为主旗舰店”中钻石、VIP以及普通会员的交易；</p>
						<p class="sale_rule_title">不在规则内的渠道：</p>
						<p class="sale_rule_info">1、线下自提渠道</p>
						<p class="sale_rule_info">2、小程序渠道皇冠会员销量</p>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>

		<a-modal title="目标制定" :visible="targetvisible" @ok="targetOk" :confirmLoading="confirmLoading" @cancel="targetCancel">
			<div class="newsku"><span class="newskutext">季度</span>
				<a-select :value="year" style="width: 120px" disabled>
					<a-select-option :value="year" v-for="(year,index) in yearlist" :key="index">
						{{year}}
					</a-select-option>
				</a-select>
				<a-select :value="quarter" style="width: 120px" disabled>
					<a-select-option :value="1">
						第一季度
					</a-select-option>
					<a-select-option :value="2">
						第二季度
					</a-select-option>
					<a-select-option :value="3">
						第三季度
					</a-select-option>
					<a-select-option :value="4">
						第四季度
					</a-select-option>
				</a-select>
			</div>
			<div class="newsku"><span class="newskutext">选择商品</span>
				<a-select :value="target.sku_id" style="width: 250px" placeholder="请选择商品" @change="target_sku">
					<a-select-option :value="sku.id" v-for="(sku,index) in data" :key="index" :disabled="sku.target!='未设置目标'">
						{{sku.sku_name+" "}}{{sku.target!='未设置目标'?'目标已设置':''}}
					</a-select-option>
				</a-select>
			</div>
			<div class="newsku"><span class="newskutext">季度目标</span>
				<a-input style="width: 250px;" v-model="target.target" placeholder="请输入季度目标" />
			</div>
		</a-modal>

		<a-modal title="数据修改" :visible="compilevisible" @ok="compileOk" :confirmLoading="confirmLoading" @cancel="compileCancel">

			<div class="newsku"><span class="newskutext">销售数</span>
				<a-input style="width: 250px;" v-model="compile.sale_number" placeholder="请输入销售数" />
			</div>
			<div class="newsku"><span class="newskutext">货损数</span>
				<a-input style="width: 250px;" v-model="compile.damage_number" placeholder="请输入货损数" />
			</div>
		</a-modal>

		<a-modal title="新增记录" :width="600" :visible="newlogvisible" @ok="newlogOk" :confirmLoading="confirmLoading" @cancel="newlogCancel">
			<div class="newsku"><span class="newskutext">记录时间</span>
				<a-select :value="year" style="width: 120px" disabled>
					<a-select-option :value="year" v-for="(year,index) in yearlist" :key="index">
						{{year}}
					</a-select-option>
				</a-select>
				<a-select :value="quarter" style="width: 120px" disabled>
					<a-select-option :value="1">
						第一季度
					</a-select-option>
					<a-select-option :value="2">
						第二季度
					</a-select-option>
					<a-select-option :value="3">
						第三季度
					</a-select-option>
					<a-select-option :value="4">
						第四季度
					</a-select-option>
				</a-select>
				<a-select :value="newlog.month" style="width: 120px" placeholder="请选择月份" @change="newlog_month">
					<a-select-option :value="month.value" v-for="(month,index) in month_list" :key="index">
						{{month.name}}
					</a-select-option>
				</a-select>
			</div>
			<div class="newsku"><span class="newskutext">选择商品</span>
				<a-select :value="newlog.sku_id" style="width: 250px" placeholder="请选择商品" @change="newlog_sku">
					<a-select-option :value="sku.id" v-for="(sku,index) in data" :key="index">
						{{sku.sku_name}}
					</a-select-option>
				</a-select>
			</div>
			<div class="newsku"><span class="newskutext">选择记录端</span>
				<a-select :value="newlog.terminal_id" style="width: 250px" placeholder="请选择记录端" @change="newlog_terminal">
					<a-select-option :value="terminal.id" v-for="(terminal,index) in terminal_list" :key="index">
						{{terminal.terminal_name}}
					</a-select-option>
				</a-select>
			</div>
			<div class="newsku"><span class="newskutext">销售数</span>
				<a-input style="width: 250px;" v-model="newlog.sale_number" placeholder="请输入销售数" />
			</div>
			<div class="newsku"><span class="newskutext">货损数</span>
				<a-input style="width: 250px;" v-model="newlog.damage_number" placeholder="请输入货损数" />
			</div>
		</a-modal>


	</div>
</template>

<script>
	import moment from 'moment';
	export default {

		data() {
			return {
				current: ['salemainpage'],
				openKeys: [''],
				reloading: true,
				data: [],
				terminal_list: [],
				columns: [],
				innerColumns: [],
				// quarter:this.moment().quarter()==1?4:this.moment().quarter()-1,
				quarter: Number(this.$route.query.quarter) || this.moment().quarter(),
				year: Number(this.$route.query.year) || this.moment().year(),
				yearlist: [2020, 2021, 2022, 2023, 2024, 2025],
				is_old_data: false,

				confirmLoading: false,
				targetvisible: false,
				target: {
					sku_id: undefined,
					target: null
				},
				compilevisible: false,
				compile: {
					sale_number: null,
					damage_number: null
				},
				newlogvisible: false,
				newlog: {
					sku_id: undefined,
					month: undefined,
					terminal_id: undefined,
					sale_number: null,
					damage_number: null
				},

			}
		},
		created: function() {
			this.initialize();
		},
		computed: {
			scroll_info(){
				return { x: this.terminal_list.length*100+1200, y: 400 }
			},
			month_list() {
				switch (this.quarter) {
					case 1:
						return [{
							value: 1,
							name: '一月'
						}, {
							value: 2,
							name: '二月'
						}, {
							value: 3,
							name: '三月'
						}]
						break;
					case 2:
						return [{
							value: 4,
							name: '四月'
						}, {
							value: 5,
							name: '五月'
						}, {
							value: 6,
							name: '六月'
						}]
						break;
					case 3:
						return [{
							value: 7,
							name: '七月'
						}, {
							value: 8,
							name: '八月'
						}, {
							value: 9,
							name: '九月'
						}]
						break;
					case 4:
						return [{
							value: 10,
							name: '十月'
						}, {
							value: 11,
							name: '十一月'
						}, {
							value: 12,
							name: '十二月'
						}]
						break;
				}
			}
		},
		methods: {
			moment,
			initialize() {
				this.reloading = true;
				var self = this;

				var innerColumns = [{
						title: '端名称',
						dataIndex: 'terminal_name',
						key: 'terminal_name'
					},
					{
						title: '月',
						dataIndex: 'month',
						key: 'month'
					},
					{
						title: '周',
						dataIndex: 'week',
						key: 'week'
					},
					{
						title: '销售数',
						dataIndex: 'sale_number',
						key: 'sale_number'
					},
					{
						title: '货损数',
						dataIndex: 'damage_number',
						key: 'damage_number'
					},
					{
						title: '操作',
						dataIndex: 'operation',
						key: 'operation',
						scopedSlots: {
							customRender: 'operation'
						},
					},
				];

				this.innerColumns = innerColumns;



				var params = {
					year: this.year,
					quarter: this.quarter,
				};

				this.$axios.get('/sale/get_main_data', {
					params: params
				}).then(function(res) {
					var columns = [{
							title: '季度目标',
							width: 100,
							dataIndex: 'target',
							key: 'target',
						},
						{
							title: '实际销售',
							width: 100,
							dataIndex: 'practical',
							key: 'practical',
						},
						{
							title: '货损数量',
							width: 100,
							dataIndex: 'damage',
							key: 'damage',
						},
						{
							title: '产品名',
							width: 100,
							dataIndex: 'sku_name',
							key: 'sku_name',
						},
					];
					var terminal_key_list = []
					for (var i = 0; i < res.data.terminal_list.length; i++) {
						var key = 'teminal' + res.data.terminal_list[i].id
						terminal_key_list.push(key)
						var temp = {
							title: res.data.terminal_list[i].terminal_name,
							dataIndex: key,
							key: key,
							width: 100
						}
						columns.push(temp);
					}

					var operate_columns = {
						title: '业务',
						dataIndex: 'operate_number',
						key: 'operate_number',
						width: 100,
					}
					var technical_columns = {
						title: '支撑',
						dataIndex: 'technical_number',
						key: 'technical_number',
						width: 100,
					}
					columns.push(operate_columns)
					columns.push(technical_columns)

					self.columns = columns;



					var source_data = res.data.data;
					var temp_data = [];
					for (var i = 0; i < source_data.length; i++) {
						var practical = 0;
						var damage = 0;
						var innerData = [];
						var temp_row = {
							key: i,
							id: source_data[i].id,
							target: "未设置目标",
							practical: practical,
							damage: damage,
							sku_name: source_data[i].sku_name,
							operate_number: "未设置目标",
							technical_number: "未设置目标",
						}

						for (var k = 0; k < terminal_key_list.length; k++) {
							temp_row[terminal_key_list[k]] = 0;
						}

						for (var j = 0; j < source_data[i].SALE_Logs.length; j++) {
							temp_row.practical += source_data[i].SALE_Logs[j].sale_number;
							temp_row.damage += source_data[i].SALE_Logs[j].damage_number;
							var key = 'teminal' + source_data[i].SALE_Logs[j].terminal_id
							temp_row[key] += source_data[i].SALE_Logs[j].sale_number;

							innerData.push({
								key: j,
								id: source_data[i].SALE_Logs[j].id,
								terminal_name: source_data[i].SALE_Logs[j].SALE_Terminal.terminal_name,
								month: source_data[i].SALE_Logs[j].month + "月",
								week: "第" + source_data[i].SALE_Logs[j].week + "周",
								sale_number: source_data[i].SALE_Logs[j].sale_number,
								damage_number: source_data[i].SALE_Logs[j].damage_number,
								can_compile: self.moment().diff(source_data[i].SALE_Logs[j].created_at, 'days') <= 7 ? true : false
							});
						}

						if (source_data[i].SALE_Targets.length) {
							temp_row.target = source_data[i].SALE_Targets[0].target;
							if (temp_row.practical > temp_row.target) {
								temp_row.operate_number = (((temp_row.practical - temp_row.target) * source_data[i].sale_price) - temp_row.damage *
									source_data[i].damage_price) * source_data[i].operate_ratio / 1000000
								temp_row.technical_number = (((temp_row.practical - temp_row.target) * source_data[i].sale_price) - temp_row.damage *
									source_data[i].damage_price) * source_data[i].technical_ratio / 1000000
								if (temp_row.operate_number <= 0) {
									temp_row.operate_number = 0
								}
								if (temp_row.technical_number <= 0) {
									temp_row.technical_number = 0
								}
							} else {
								temp_row.operate_number = 0;
								temp_row.technical_number = 0;
							}
						}
						temp_row.innerData = innerData
						temp_data.push(temp_row)
					}
					self.is_old_data = res.data.is_old_data
					self.data = temp_data;
					self.terminal_list = res.data.terminal_list
					self.reloading = false;
				});
			},
			quarterChange(value) {
				this.quarter = value;
			},
			yearChange(value) {
				this.year = value;
			},
			gotopage(page) {
				this.$router.push(page);
			},
			bianjibtn(record) {
				this.compile = {
					id: record.id,
					sale_number: record.sale_number,
					damage_number: record.damage_number,
				}
				this.compilevisible = true;
			},
			compileOk(e) {
				var self = this;
				if (this.compile.sale_number == null || this.compile.sale_number == '') {
					return this.$message.error("销售数不能为空");
				}
				if (this.compile.damage_number == null || this.compile.damage_number == '') {
					return this.$message.error("货损数不能为空");
				}
				this.confirmLoading = true;
				this.$confirm({
					title: '提示',
					content: '是否提交此次修改',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/sale/savechangelog', {
							params: self.compile
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.confirmLoading = false;
							self.compilevisible = false;
							self.compile = {
								sale_number: null,
								damage_number: null
							};
							self.initialize();
						});
					},
					onCancel() {
						self.confirmLoading = false;
					},
				});
			},
			compileCancel(e) {
				this.compilevisible = false;
			},
			search_btn() {
				this.initialize();
				this.$router.push({
					name: 'salemainpage',
					query: {
						year: this.year,
						quarter: this.quarter,
					}
				})
			},
			targetbtn() {
				this.targetvisible = true;
			},
			targetOk(e) {
				var self = this;
				if (!this.target.sku_id) {
					return this.$message.error("请选择商品");
				}
				if (!this.target.target) {
					return this.$message.error("季度目标不能为空");
				}
				this.target.year = this.year;
				this.target.quarter = this.quarter;
				this.confirmLoading = true;
				this.$confirm({
					title: '提示',
					content: '是否确定该商品此季度目标',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/sale/savetarget', {
							params: self.target
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.confirmLoading = false;
							self.targetvisible = false;
							self.target = {
								sku_id: undefined,
								target: null
							};
							self.initialize();
						});
					},
					onCancel() {
						self.confirmLoading = false;
					},
				});
			},
			targetCancel(e) {
				this.targetvisible = false;
				this.target = {
					sku_id: undefined,
					target: null
				}
			},
			target_sku(value) {
				this.target.sku_id = value
			},
			newlog_sku(value) {
				this.newlog.sku_id = value
			},
			newlog_month(value) {
				this.newlog.month = value
			},
			newlog_terminal(value) {
				this.newlog.terminal_id = value
			},
			newlogbtn() {
				this.newlogvisible = true;
			},
			newlogOk(e) {
				var self = this;
				if (!(this.newlog.month)) {
					return this.$message.error("月份选择不能为空");
				}
				if (!(this.newlog.terminal_id)) {
					return this.$message.error("记录端选择不能为空");
				}
				if (!(this.newlog.sku_id)) {
					return this.$message.error("商品选择不能为空");
				}
				if (this.newlog.sale_number == null || this.newlog.sale_number == '') {
					return this.$message.error("销售数不能为空");
				}
				if (this.newlog.damage_number == null || this.newlog.damage_number == '') {
					return this.$message.error("货损数不能为空");
				}
				this.newlog.year = this.year;
				this.newlog.quarter = this.quarter;
				this.confirmLoading = true;
				this.$confirm({
					title: '提示',
					content: '是否提交此次新增记录',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/sale/savenewlog', {
							params: self.newlog
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.confirmLoading = false;
							self.newlogvisible = false;
							self.newlog = {
								sku_id: undefined,
								month: undefined,
								terminal_id: undefined,
								sale_number: null,
								damage_number: null
							}
							self.initialize();
						});
					},
					onCancel() {
						self.confirmLoading = false;
					},
				});
			},
			newlogCancel(e) {
				this.newlogvisible = false;
				this.newlog = {
					sku_id: undefined,
					month: undefined,
					terminal_id: undefined,
					sale_number: null,
					damage_number: null
				}
			},
		},

	};
</script>

<style>
	.salemainpage .contentcard {
		padding: 24px 20px;
		background-color: #fff;
		/* min-height: 300px; */
		border-radius: 5px;
		margin-bottom: 20px;
	}

	.newsku {
		margin-left: 30px;
		margin-bottom: 10px;
	}

	.newsku .newskutext {
		width: 100px;
		font-weight: 700;
		display: inline-block;
	}
	.sale_rule{
		font-size: 12px;
		color: #999;
	}
	.sale_rule>p{
		margin-bottom: 0px;
	}
	.sale_rule .sale_rule_title{
		margin-top: 5px;
	}
	.sale_rule .sale_rule_info{
		text-indent:2em;
	}
</style>



// WEBPACK FOOTER //
// index.vue?46f11b50